module.exports = __webpack_public_path__ + "img/amazon-logo.caec5f9b.png";